<template>
    <div>
        <slot
        :loading="loading"
        :results="results"
        :filters="filters"
        :processresults="processResults"
        :searchReact="searchReact"
        />
    </div>
</template>

<script>
import { defineComponent, onMounted, ref, watchEffect, watch } from 'vue';
import { cloneDeep, flatten, uniqBy, groupBy, sortBy } from 'lodash';
import Fuse from 'fuse.js';
import { getEvents } from '../services/inventory';
import zonedDate from '../utils/zoned-date';

export default defineComponent({
    name: 'WhatsOnEvents',
    setup(props) {
        const search = ref('');

        const loading = ref(true);
        const results = ref([]);
        const filters = ref([]);
        const events = ref([]);
        const fuse = ref(null);

        const searchReact = (event) => {
            search.value = event;

            processResults();
        }

        const setupFilters = () => {
            let aggregatedFilters = [
                // {
                //     title: 'Event Season',
                //     field: 'event_seasons',
                //     facets: [],
                // },
                {
                    title: 'Event Series',
                    field: 'event_series',
                    facets: [],
                },
                {
                    title: 'Event Type',
                    field: 'event_types',
                    facets: [],
                },
                {
                    title: 'Venues',
                    field: 'venues',
                    facets: [],
                },
                {
                    title: 'Keywords',
                    field: 'keywords',
                    facets: [],
                }
            ];

            aggregatedFilters = aggregatedFilters.map(filter => {
                let facets = events.value.map(item => {
                    return cloneDeep(item.filters[filter.field]);
                });

                facets = flatten(facets);

                facets = uniqBy(facets, facet => {
                    return facet.title;
                });

                filter.facets = facets.map(facet => {
                    facet.is_checked = false;
                    facet.is_disabled = false;

                    return facet;
                });

                return filter;
            });

            filters.value = aggregatedFilters;
        }

        const processResults = () => {
            const andQuery = [];

            for (const filter of filters.value) {
                const orQuery = [];

                for (const facet of filter.facets) {
                    if (facet.is_checked) {
                        orQuery.push({
                            [`filters.${filter.field}.title`]: facet.title,
                        })
                    }
                }

                if (orQuery.length) {
                    andQuery.push({
                        ['$or']: orQuery,
                    });
                }
            }

            if (search.value) {
                andQuery.push({
                    ['title']: `'${search.value}`,
                });
            }

            console.log(andQuery);

            let eventsResults = events.value;

            if (andQuery.length) {
                eventsResults = fuse.value.search({
                    '$and': andQuery,
                }).map(result => {
                    return result.item;
                });
            }

            results.value = eventsResults;
        }

        onMounted(async () => {
            events.value = await getEvents();

            setupFilters();

            fuse.value = new Fuse(events.value, {
                threshold: 0.40,
                useExtendedSearch: true,
                includeScore: false,
                shouldSort: false,
                keys: [
                    'title',
                    'filters.event_types.title',
                    'filters.venues.title',
                    'filters.event_series.title',
                    //'filters.event_seasons.title',
                    'filters.keywords.title',
                ],
            });

            processResults();

            loading.value = false;
        });

        return {
            loading,
            results,
            filters,
            processResults,
            searchReact,
        }
    },
})
</script>
